import { render, staticRenderFns } from "./FeatureCreateScreen.vue?vue&type=template&id=f8259be8&"
import script from "./FeatureCreateScreen.vue?vue&type=script&lang=js&"
export * from "./FeatureCreateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports